import { BaseAuditModel } from 'modules/shared/models/base.models';

export interface Record extends BaseAuditModel {
  addresses?: Array<string>;
  aliasNames?: Array<string>;
  bankAccounts?: Array<string>;
  emailAddresses?: Array<string>;
  oldNames?: Array<string>;
  phoneNumbers?: Array<string>;
  dialog?: number;
  fileBucket?: number;
  name: string;
  recordType: string;
  referenceId?: string;
  sourceOfFunds?: string;
}

export interface IndividualRecord extends Record {
  countryOfBirth?: string;
  countryOfResidence?: string;
  dateOfBirth?: string;
  gender?: string;
  handshakesReports?: Array<object>;
  idExpiryDate?: string;
  idIssueDate?: string;
  idNumber?: string;
  idType?: string;
  industry?: string;
  nationality?: string;
  occupation?: string;
  title?: string;
  paymentModes?: Array<string>;
  onboardingMode?: string;
  productServiceComplexity?: string;
}

export interface CorporateRecord extends Record {
  businessActivity?: string;
  countryOfIncorporation?: string;
  countryOfOperations?: string;
  entityType?: string;
  handshakesReports?: Array<string>;
  inFatfJurisdiction?: boolean;
  incorporationDate?: string;
  incorporationExpiryDate?: string;
  incorporationNumber?: string;
  isIncorporated?: boolean;
  ownershipStructureLayers?: string;
  website?: string;
  paymentModes?: Array<string>;
  onboardingMode?: string;
  productServiceComplexity?: string;
  imoNumber?: string;
}

export enum RecordType {
  CORPORATE = 'CORPORATE',
  INDIVIDUAL = 'INDIVIDUAL'
}

export interface RecordOcr extends BaseAuditModel {
  ocrOutput: string;
  ocrComments: string;
  compareResult: VerificationResult;
  record: number;
  doc: number;
}

export interface RecordFaceCompare extends BaseAuditModel {
  awsScore: number;
  faceComments: string;
  compareResult: VerificationResult;
  record: number;
  source: number;
  target: number;
}

export enum VerificationResult {
  UNCERTAIN = 'UNCERTAIN',
  MATCH = 'MATCH',
  MISMATCH = 'MISMATCH'
}

export enum VerificationType {
  FACE = 'FACE',
  OCR = 'OCR'
}

export interface VerificationConclusion {
  id: number;
  createdBy: Account;
  updatedBy: Account;
  createdAt: string;
  updatedAt: string;
  verificationType: VerificationType;
  verificationResult: VerificationResult;
  crp: number;
}

export interface LatestVerificationConclusion {
  [key: number]: VerificationConclusion;
}

export interface DetailFormOption {
  exclude_customer_id?: number;
}

export interface RecordOtherDataItem extends BaseAuditModel {
  data: {
    surveys: string;
  };
  record: number;
  customer: number;
}

export interface RecordOtherDataFormsJSON {
  [formName: string]: string;
}

export interface RecordOtherDataFormsObject {
  [formName: string]: RecordOtherDataFormContent;
}

export interface RecordOtherDataFormContent {
  [question: string]: any;
}
